import { useFormikContext } from "formik";
import { Checkbox, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import Price from "@/components/Price";
import { FormValues } from "../ProductDetails";
import { sanitizeNumber } from "@/utils/numbers";
import { Setting } from "@/types";

interface Props {
  settings?: Setting[];
}

const ProductSettings = ({ settings = [] }: Props) => {
  const { values, handleChange } = useFormikContext<FormValues>();

  if (!settings.length) return null;

  return (
    <Stack spacing={3}>
      {settings.map((setting) => (
        <Stack key={setting.id}>

          {setting.title ? (
            <Typography fontSize={"18px"} fontWeight={700}>
              {setting.title}:
            </Typography>
          ) : null}

          {(setting?.options ?? []).map((option) => {
            if (option.type === "subtitle") {
              return (
                <Typography key={option.id} variant="h4" my={2}>
                  {option.title}
                </Typography>
              )
            }

            return (
              <div key={option.id}>
                {setting.max > 1 ? (
                  <FormControlLabel
                    label={
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        flex={1}
                        sx={{
                          width: "100%",
                        }}
                      >
                        <Stack flex={1} direction="row" justifyContent="start">
                          {option.title}
                        </Stack>
                        <Stack>
                          { sanitizeNumber(option.price) ?
                            <Price currency="NIO">{option?.price}</Price> 
                            : 
                            null
                            }
                          </Stack>
                      </Stack>
                    }
                    control={
                      <Checkbox
                        name={`settings[${setting.id}]`}
                        value={option.id}
                        defaultChecked={setting.defaultOption?.includes(option.id)}
                        disabled={values.settings[setting.id]?.length >= setting.max && !values.settings[setting.id]?.includes(option.id)}
                        onChange={(e) => {
                          const { checked } = e.target;
                          const newValues = checked ? [...(values.settings[setting.id] || []), option.id] : values.settings[setting.id].filter((id: string) => id !== option.id);
                          handleChange({
                            target: {
                              name: `settings[${setting.id}]`,
                              value: newValues,
                            },
                          });
                        }}
                      />
                    }
                    sx={{
                      width: "100%",
                      margin: 0,
                      "& .MuiTypography-root": {
                        width: "100%",
                      },
                    }}
                  />
                ) : (
                  <RadioGroup
                    name={setting.id}
                  >
                    <FormControlLabel
                      label={
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          flex={1}
                          sx={{
                            width: "100%",
                          }}
                        >
                          <Stack flex={1} direction="row" justifyContent="start">
                            {option.title}
                          </Stack>
                          <Stack>
                            { sanitizeNumber(option.price) ?
                            <Price currency="NIO">{option?.price}</Price> 
                            : 
                            null
                            }
                           </Stack>
                        </Stack>
                      }
                      name={`settings[${setting.id}]`}
                      checked={values.settings[setting.id]?.includes(option.id)}
                      value={option.id}
                      control={<Radio />}
                      onChange={handleChange}
                      sx={{
                        width: "100%",
                        margin: 0,
                        "& .MuiTypography-root": {
                          width: "100%",
                        },
                      }}
                    />
                  </RadioGroup>
                )}
              </div>
            );
          })}
        </Stack>
      ))}
    </Stack>
  );
};

export default ProductSettings;
